import wbsBookingsApi from '../apis/wbsBookingsApi';

export const deleteBookingQueuesService = async (
  bookingQueueId: string,
): Promise<void> => {
  await wbsBookingsApi.delete(`/booking-queues/${bookingQueueId}`);
};
